export const changePricingPlanTab = () => {
  const buttons = document.querySelectorAll(".pricing-tabs-btn-group .btn");
  if (buttons) {
    for (const button of buttons) {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        buttons.forEach((button) => {
          button.classList.remove("active");
        });
        this.classList.add("active");
        const type = button.getAttribute("href");
        const yearly = document.querySelectorAll("[data-yearly]");
        const monthly = document.querySelectorAll("[data-monthly]");
        if (type == "#yearly") {
          yearly.forEach((element) => {
            element.classList.remove("hidden");
          });
          monthly.forEach((element) => {
            element.classList.add("hidden");
          });
        }
        if (type == "#monthly") {
          yearly.forEach((element) => {
            element.classList.add("hidden");
          });
          monthly.forEach((element) => {
            element.classList.remove("hidden");
          });
        }
      });
    }
  }
};
